import request from "./http";

class FinancialChannelRepository
{
    async getAll() {
        const path = "financial-channels";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }
}

export default FinancialChannelRepository;